<template>
    <div class="container">
        <h4 class="text-primary">Seleccione su método de pago preferido</h4>
        <div class="col-md-8 col-12 p-0">
            <div class="row">
                <div class="col-12 col-md-4" v-for="item in lista" :key="item.id">
                    <label class="kt-option">
                    <span class="kt-option__control">
                        <span class="kt-radio">
                            <input type="radio" :value="item.id" name="pago" v-model="metodo">
                            <span></span>
                        </span>
                    </span>
                        <span class="kt-option__label">
                        <span class="kt-option__head">
                            <span class="kt-option__title">{{item.title}}</span>
                            <span class="kt-option__focus"></span>
                        </span>
                    </span>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 order-2 order-md-1">
                <div class="kt-portlet">
                    <div class="kt-portlet__body">
                        <div class="kt-section">
                            <fade-transition origin="center" mode="in-out" :duration="100">
                                <div class="kt-section__content" v-if="metodo===1">
                                    <tarjetas></tarjetas>
                                </div>
                                <div class="kt-section__content" v-else-if="metodo===2">
                                    <div class="pt-3 pb-5">
                                        <div class="pt-3">
                                            <h5 class="text-primary">1. Datos de pago</h5>
                                            <div class="ml-3 row">
                                                <p>Los datos bancarios para que pueda realizar su compra se enviarán a su correo electrónico <b>{{email}}</b></p>
                                                <div class="col-12">
                                                    <button type="button" :class="cargandoBtn && 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light'" :disabled="cargandoBtn" class="btn btn-primary btn-elevate btn-pill btn-block" v-on:click="irLicitud">
                                                        Enviar datos
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-3 pb-5">
                                        <div class="pt-3">
                                            <h5 class="text-primary">2. Realice su pago</h5>
                                            <div class="ml-3 row">
                                                <p>Realice su pago mediante transferencia electrónica. Una vez realizado su pago no se olvide de guardar el comprobante de transacción.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-3 pb-5">
                                        <div class="pt-3">
                                            <h5 class="text-primary">3. Ingrese los datos de su transacción</h5>
                                            <transferencia
                                                    :tipo="objTipo"
                                            ></transferencia>
                                        </div>
                                    </div>
                                </div>
                                <div class="kt-section__content" v-else-if="metodo===3">
                                    <div class="pt-3 pb-5">
                                        <div class="pt-3">
                                            <h5 class="text-primary">1. Datos de pago</h5>
                                            <div class="ml-3 row">
                                                <p>Los datos bancarios para que pueda realizar su compra se enviarán a su correo electrónico <b>{{email}}</b></p>
                                                <div class="col-12">
                                                    <button type="button" :class="cargandoBtn && 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light'" :disabled="cargandoBtn" class="btn btn-primary btn-elevate btn-pill btn-block" v-on:click="irLicitud">
                                                        Enviar datos
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-3 pb-5">
                                        <div class="pt-3">
                                            <h5 class="text-primary">2. Realice su pago</h5>
                                            <div class="ml-3 row">
                                                <p>Realice su pago mediante depósito bancario. Una vez realizado su pago no se olvide de guardar el comprobante de transacción.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-3 pb-5">
                                        <div class="pt-3">
                                            <h5 class="text-primary">3. Ingrese los datos de su transacción</h5>
                                            <transferencia
                                                    :tipo="objTipo"
                                                    :enabled="cotizacion.bdt1"
                                            ></transferencia>
                                        </div>
                                    </div>
                                </div>
                                <div class="kt-section__content" v-else>
                                    <div class="pb-5">
                                        <img src="@/assets/images/logo_large.png" class="img-fluid" >
                                    </div>
                                    <div class="text-justify pt-3 pb-5">
                                        Estimado cliente:
                                        <br><br>
                                        Para ofrecer una mejor experiencia en su proceso de compra Online, ponemos a su disposición tres alternativas en sus formas de pago. Puede elegir su preferida y también puede combinarlos para cubrir el costo total de sus compras.
                                        <br><br>
                                        Es importante recordarle que todas las transacciones en nuestros sitios web están protegidas según la <span class="text-primary" v-on:click="politicas">política de privacidad</span> y cuentan con certificados de encriptación y protección de datos.
                                    </div>
                                </div>
                            </fade-transition>
                            <hr>
                            <div class="text-center m-5">
                                <img src="@/assets/images/pay-certification.png" class="img-fluid" >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 order-1 order-md-2">
                <resumen></resumen>
            </div>
        </div>
        <b-modal ref="politica" size="lg" hide-footer hide-header title="Kia" body-class="m-0 p-0">
            <modal-terminos v-on:aceptado="politicas"></modal-terminos>
        </b-modal>
    </div>
</template>

<script>
    import resumen from "../../../../componentes/resumen-vertical-online";
    import transferencia from '../../../../componentes/formularios/transferencia';
    import tarjetas from "./tarjetas";
    import { FadeTransition } from "vue2-transitions";
    import {negociacion, persona} from "../../../../servicios";
    import modalTerminos from "../../../../componentes/modal-terminos";
    import _ from 'lodash';
    import constantes from "../../../../constantes";
    export default {
        name: "contado",
        data:()=>({
            metodo:null,
            archivo:null,
            cargandoBtn:false,
            lista:constantes.Constantes.enumeraciones.pagosMetodos,
            objTipo:null,
        }),
        watch:{
            metodo:function(val){
                this.objTipo=this.lista.find(i=>i.id===val);
            }
        },
        components:{
            resumen,
            tarjetas,
            transferencia,
            FadeTransition,
            modalTerminos
        },
        methods:{
            irLicitud:function(){
                this.cargandoBtn=true;
                this.enviar();
            },
            enviar:_.debounce(function () {
                const cotizacion = this.$store.getters.getCotizacion;
                negociacion.envioEmailDatosAgencia().then(()=>{
                    this.$toast.info(`Se ha enviado un email con los datos de la transacción`);
                });
                persona.validarDatos().then(()=>{
                    this.redirigir(cotizacion.bdt1)
                }).catch(()=>{
                    this.redirigir(false)
                });
            },5000),
            redirigir: function (tipo) {
                const cotizacion = this.$store.getters.getCotizacion;
                const mensaje = cotizacion.bdt4 ? 'solicitud de credito' : 'licitud de fondos';
                this.cargandoBtn=false;
                if (!tipo) {
                    this.$store.commit("setPago",
                        {
                            tipo:this.objTipo,
                            pasarela:null,
                            valor:null
                        }
                    );
                  this.$swal({
                    html: `<div class="text-left"><br><b>Estimado cliente<br><br>Antes de continuar con su proceso  de pago, es importante realizar una aceptación de ${mensaje}, por lo que le pedimos tomarse un momento para llenar la siguiente declaración.</b></div>`,
                    showLoaderOnConfirm: true,
                    showCancelButton: true,
                    confirmButtonText: 'Si',
                    confirmButtonAriaLabel: 'No',
                    cancelButtonText: 'No',
                    cancelButtonAriaLabel: 'Si',
                    preConfirm: () => {
                      this.$router.push({name:cotizacion.bdt4 ? 'compras.credito.solicitud' : 'compras.contado.licitud'});
                    }
                  });
                }
            },
            politicas:function(){
                this.$refs['politica'].toggle();
            }
        },
        computed:{
            email:function(){
                return this.$store.getters.getUsuario.dt2
            },
          cotizacion:function(){
            return this.$store.getters.getCotizacion
          }
        },
        mounted() {
            if(this.$route.query.tab){
                this.metodo=parseInt(this.$route.query.tab);
            }
        },
        created() {
            negociacion.busquedaId();
        }
    }
</script>

<style scoped>
    img{
        max-width: 200px !important;
    }
    .kt-option{
        cursor: pointer;
    }
</style>
